import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options }) {
    return (
        <div className="ns-relative ns-d-flex ns-justify-content-between ns-align-items-center">
            <label class="ns-sort-label" for="SortBy">Sort by:</label>
            <div class="ns-relative">
                <select
                    className={`ns-selection-dropdown-menu ns-text-align-left ns-font-2 ${className}`}
                    value={value}
                    onChange={onChange}
                    id="SortBy"
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </path>
                </svg>
            </div>
        </div>
    )
}